import React from 'react';
import SmartDisplayIcon from '@mui/icons-material/SmartDisplay';

import {
  Container,
  VehicleArea,
  AreaTitle,
  Row,
  Column,
  VideoContainer,
  AreaTitleContainer,
  AreaSubtitle,
} from './styles';

export const VehicleVideos = props => {
  const { auction } = props;

  const removeJpgLinks = photos =>
    photos?.filter(url => typeof url === 'string' && !url.endsWith('.jpg') && url.includes('vimeo')) || [];
  const videoUrls = removeJpgLinks(auction?.summary?.photos);

  // Guard: if there are no valid videos, render nothing
  if (!videoUrls || videoUrls.length === 0) return null;

  return (
    <Container>
      <VehicleArea>
        <AreaTitleContainer>
          <AreaTitle>
            <SmartDisplayIcon sx={{ marginRight: 1 }} />
            Vídeos
          </AreaTitle>
        </AreaTitleContainer>
        <Row>
          {videoUrls.map((url, index) => (
            <Column key={index} width={videoUrls.length > 1 ? `${100 / videoUrls.length}%` : '50%'}>
              <VideoContainer>
                <iframe
                  src={url}
                  width="100%"
                  height="100%"
                  frameBorder="0"
                  allow="autoplay; fullscreen; picture-in-picture"
                  allowFullScreen
                  title={`Vídeo ${index + 1}`}
                />
              </VideoContainer>
            </Column>
          ))}
        </Row>
      </VehicleArea>
    </Container>
  );
};
